<div class="w-100">
  <h2 class="mb-5">Awards &amp; Certifications</h2>

  <div
    class="mat-elevation-z8"
    [ngClass]="DarkMode ? 'dark-mode-card' : 'light-mode-card'"
  >
    <mat-table matSort [dataSource]="dataSource">
      <ng-container matColumnDef="course">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          [ngClass]="DarkMode ? 'dark-mode-card' : 'light-mode-card'"
        >
          <strong>Course</strong>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="DarkMode ? 'dark-mode-card' : 'light-mode-card'"
        >
          {{ element.course }}
        </td>
      </ng-container>

      <ng-container matColumnDef="organization">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          [ngClass]="DarkMode ? 'dark-mode-card' : 'light-mode-card'"
        >
          <strong>Organization</strong>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="DarkMode ? 'dark-mode-card' : 'light-mode-card'"
        >
          {{ element.organization }}
        </td>
      </ng-container>
      <ng-container matColumnDef="view">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          [ngClass]="DarkMode ? 'dark-mode-card' : 'light-mode-card'"
        ></th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="DarkMode ? 'dark-mode-card' : 'light-mode-card'"
        >
          <a mat-button href="{{ element.certificateUrl }}" target="_blank">
            <mat-icon>open_in_new</mat-icon>
          </a>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </mat-table>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      [ngClass]="DarkMode ? 'dark-mode-card' : 'light-mode-card'"
    ></mat-paginator>
  </div>
</div>
